import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import styled from "styled-components";


// import n_img from "../partners/tools/science_cover.jpg";
import n_img from "../partners/tools/soyuz.jpg";
import ScienceSelectTool from "../partners/tools/ScinceSelectTool";
import AmbassadorViewTool from "../ambassadors/tools/AmbassadorViewTool";
import axios from "axios";
import { useParams } from "react-router-dom";

async function getAmbassador(id) {
    console.log('getAmbassador id = ', id);
    let arr = (await axios.get(`/ambassadors/all`)).data;
    console.log('getAmbassador: arr = ', arr);
    let pld = arr.find(x => (x.id == id));
    return pld;
}

const AmbassadorPage = () => {
    const { t } = useTranslation();
    const { ambassadorId, postId } = useParams();

    const [ambassador, setAmbassador] = useState();

    useEffect(() => {
        getAmbassador(ambassadorId).then(d => {
            setAmbassador(d);
        });
    }, [ambassadorId])

    console.log('ambassador = ', ambassador);

    return (
        <OuterWrapper className={"ambassador"}>

            <Wrapper>
                {/*<TopImg src={n_img} />*/}

                <TopPlaceholder>


                </TopPlaceholder>

                {/*{JSON.stringify(ambassador)}*/}

                {ambassador == undefined ? '...' :
                    <AmbassadorViewTool
                        {...ambassador}
                        postId={postId}
                    />
                }


            </Wrapper>

        </OuterWrapper>
    );
};

const TopTextPlaceholder = styled.div`
  width: 1360px;
  box-sizing: border-box;
  //padding: 15px;
  font-family: "Noto Sans", sans-serif;
  line-height: 32px;
  font-size: 24px;
  text-align: center;

  margin: 0 auto;
  text-align: justify;

  margin-bottom: 50px;
  margin-top: 50px;


  @media (max-width: 1360px) {
    width: 100%;
  }
`;


const OuterWrapper = styled.div`
  width: 100%;
  background: white;
  padding-top: 30px;
  box-sizing: border-box;
  padding-bottom: 40px;
`;

const Wrapper = styled.div`
  text-align: left;

  font-family: "Noto Sans", sans-serif;

  box-sizing: border-box;
  width: 1400px;
  margin: 0 auto;
  padding: 15px;
  @media (max-width: 1400px) {
    width: 100%;
  }
`;

const Heading = styled.div`
  font-family: "Noto Sans", sans-serif;
  text-align: center;
  font-style: normal;
  font-weight: 700;
  font-size: 56px;
  line-height: 72px;
  margin-bottom: 40px;
  @media (max-width: 820px) {
    font-size: 24px;
    line-height: 32px;
    padding-left: 5px;
  }
`;

const SupTopPlaceholder = styled.div`
  margin-bottom: 20px;
`;

const TopPlaceholder = styled.div``;

export default AmbassadorPage;
